import { lazyLoad } from 'utils/loadable';

export const EntityDiscountReportPage = lazyLoad(
  () => import('./index'),
  module => module.EntityDiscountReportPage
);
